import type { RouteRecordRaw } from 'vue-router';

export const payrollRoutes: RouteRecordRaw[] = [
  {
    path: 'payroll',
    name: 'payroll',
    component: () => import('./pages/PayrollHistoryPage.vue'),
    meta: { title: 'Payroll', requiresAuth: true, permission: 'view_payroll' },
  },
  {
    path: 'payroll/run',
    name: 'payroll.run',
    component: () => import('./pages/PayrollPage.vue'),
    meta: { title: 'Generate payroll', requiresAuth: true },
  },
  {
    path: 'payroll/report',
    name: 'payroll.report',
    component: () => import('./pages/SalaryReportPage.vue'),
    meta: { title: 'Salary report', requiresAuth: true },
  },
  {
    path: 'payroll/:id',
    name: 'payroll.show',
    component: () => import('./pages/PayrollPage.vue'),
    meta: { title: 'Payroll', requiresAuth: true },
  },
];
